import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions';
import { getLabelingSaga, editLabelingSaga } from './labelingSaga';

export function* labelingSaga() {
  yield takeLatest(sagaActions.GET_LABELING, getLabelingSaga);
  yield takeLatest(sagaActions.EDIT_LABELING, editLabelingSaga);
}
